import React from 'react';
import bg_content from '../../../assets/images/dyslexia/bg.png';

function HeroContent() {
  return (
    <div className="relative w-full -top-[40%]">
      <img
        src={bg_content}
        alt="bg-gradient"
        className="w-full h-full absolute -top-2 left-0 z-20"
      />
      <div className="relative z-30 w-full flex flex-col justify-between gap-4 max-w-[1200px] mx-auto px-4 md:px-10">
        <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold leading-tight">
          Is It Dyslexia? A Guide for Parents
        </h2>
        <h4 className="text-[28px] sm:text-[32px] md:text-[36px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] max-w-[950px]">
          Dyslexia is a common, neurobiological learning disability that affects
          the way the brain processes language, creating challenges with
          reading, writing, and spelling. Recognizing the signs early and
          seeking the right support can make a world of difference in a child's
          academic journey and self-confidence. At Guidepost Pediatrics, we're
          here to provide the expert guidance and compassionate care your family
          needs to navigate this path successfully.
        </h4>
      </div>
    </div>
  );
}
export default HeroContent;
